import { NextSeo } from "next-seo";
import { FC } from "react";
import { Article } from "../Html/Article";
import { Heading } from "../Html/Heading";
import { FifthSection } from "./FifthSection/FifthSection";
import { FirstSection } from "./FirstSection/FirstSection";
import { ForthSection } from "./ForthSection/ForthSection";
import { Pragraph } from "./Pragraph/Pragraph";
import { SecondSection } from "./SecondSection/SecondSection";
import { ThridSection } from "./ThridSection/ThridSection";

export const Privacy: FC = () => {
  return (
    <div className="bg-primary py-[30px] text-xs md:p-[50px] md:text-base">
      <NextSeo
        title="プライバシーポリシー｜株式会社KDOT"
        description="KDOTは技術を使って利益を生むことを目的に、お客様の経営課題の解決を支援します。"
      />
      <Article className="bg-white px-[10px] py-[30px] pb-[20px] md:px-[10%] md:py-[100px]">
        <Heading className="text-center text-[1.5em]">プライバシーポリシー </Heading>
        <Pragraph className="pb-[20px] text-right">
          制定 2023.5.28 <br />
          株式会社 KDOT
        </Pragraph>
        <Pragraph>
          当社は、当社Webサイト上のフォームをご利⽤されたお客様(取引先ご担当者様を含みます。)の個⼈情報の保護について、次のとおりプライバシーポリシー(以下「本ポリシー」といいます。)を定め、本ポリシーに基づき適正に個⼈情報を取り扱います。
        </Pragraph>
        <Pragraph>
          なお、本ポリシーで使⽤する⽤語の意味は、個⼈情報の保護に関する法律(以下「個⼈情報保護法」といいます。)に準拠するものとします。
        </Pragraph>
        <ul className="flex flex-col gap-[40px] py-[40px]">
          <FirstSection />
          <SecondSection />
          <ThridSection />
          <ForthSection />
          <FifthSection />
        </ul>
      </Article>
    </div>
  );
};
